import { defineComponent } from 'vue'
import { IAuthUser } from '@/store/modules/auth/interfaces/IAuthUser'
import { permissionSchema, RolePermissionDetails } from '@/store/modules/users/interfaces/IUser'

export default defineComponent({
  methods: {
    allPermission (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.permission.split(','))
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    shipToAllPermission (user: IAuthUser, shipToId : string) {
      const permissionSchema = user?.permissionSchema?.filter((company) => company.shipToId === shipToId) || []
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.permission.split(','))
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allRoles (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.rolename)
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allShipToBasicRoles (user: IAuthUser, shipToId: string) {
      const permissionSchema = user?.permissionSchema?.filter((company) => company.shipToId === shipToId) || []
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.filter((rp: RolePermissionDetails) => rp.roleType === 'Basic')
          ?.flatMap((rp: RolePermissionDetails) => rp.rolename)
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allCompanyDetails (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return permissionSchema.map((item: permissionSchema) => {
        return { label: item.companyName, value: item.companyId }
      })
    },
    shipToDetails (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return permissionSchema.map((item: permissionSchema) => {
        return { label: item.shipToName, value: item.shipToId }
      })
    },
    checkDisableShipTo (user: IAuthUser, shipToId: string) {
      const permissionSchema = user?.permissionSchema || []

      if (shipToId != null) {
        return permissionSchema.some(
          (shipToItem: permissionSchema) => shipToItem.shipToId === shipToId && shipToItem.shipToStatus === 'SUSPENDED'
        )
      }

      if (permissionSchema.length === 1) {
        return permissionSchema[0]?.shipToStatus === 'SUSPENDED'
      }

      return false
    },
    getCompanyid (shipToId: string, user: IAuthUser) {
      let companyId = ''
      const shipToItem = user?.permissionSchema.find((item: permissionSchema) => item.shipToId === shipToId)
      if (shipToItem) {
        companyId = shipToItem?.companyId
      }
      return companyId
    },
    isOnPremiseFranchisee (permissions: permissionSchema[]):boolean {
      const shipToIdFromStorage = localStorage.getItem('shipToId')
      return permissions?.some((company) =>
        company.shipToId === shipToIdFromStorage &&
        company.rpDetails?.some((rp) => rp.customerType === 'On Premise Franchisee')
      )
    },
    isOnPremise (permissions: permissionSchema[]):boolean {
      const shipToIdFromStorage = localStorage.getItem('shipToId')
      return permissions?.some((company) =>
        company.shipToId === shipToIdFromStorage &&
        company.rpDetails?.some((rp) => rp.customerType === 'On Premise')
      )
    },
    hasCataloguePermission () {
      const { permissionSchema = [] } = this.$store.state.auth.user || {}
      const allPermissions = [...permissionSchema]
        .filter((permission) => permission.rpDetails.some((role) => role.permission.includes('Catalogue')))
      if (allPermissions.length > 0) {
        return true
      } else {
        return false
      }
    },
    getShipToAddress (shipToId: string) {
      const { permissionSchema = [] } = this.$store.state.auth.user || {}
      const shipToDetails = [...permissionSchema]
        .filter((permission) => permission.shipToId === shipToId)
      if (shipToDetails.length > 0) {
        return shipToDetails[0].shipToAddress
      }
    },
    getShipToDetails (shipToId: string) {
      const { permissionSchema = [] } = this.$store.state.auth.user || {}
      const shipToDetails = [...permissionSchema]
        .filter((permission) => permission.shipToId === shipToId)

      if (shipToDetails.length > 0) {
        return shipToDetails[0]
      } else {
        return {} as permissionSchema
      }
    }
  }
})
